import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/axiosConfig';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem('bo_token'));
  const [role, setRole] = useState(localStorage.getItem('bo_role') || 'backoffice');
  const [account, setAccount] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('bo_account'));
    } catch {
      return null;
    }
  });

  useEffect(() => {
    if (token) localStorage.setItem('bo_token', token);
    else localStorage.removeItem('bo_token');
  }, [token]);

  useEffect(() => {
    if (role) localStorage.setItem('bo_role', role);
    else localStorage.removeItem('bo_role');
  }, [role]);

  useEffect(() => {
    if (account) localStorage.setItem('bo_account', JSON.stringify(account));
    else localStorage.removeItem('bo_account');
  }, [account]);

  const login = (accessToken, accountData, userRole = 'backoffice') => {
    setToken(accessToken);
    setAccount(accountData);
    setRole(userRole);
  };

  const switchToAccount = (accessToken, accountData) => {
    localStorage.setItem('bo_sa_token', token);
    localStorage.setItem('bo_sa_account', JSON.stringify(account));
    setToken(accessToken);
    setAccount(accountData);
    setRole('backoffice');
  };

  const backToSuperAdmin = () => {
    const saToken = localStorage.getItem('bo_sa_token');
    const saAccount = JSON.parse(localStorage.getItem('bo_sa_account') || 'null');
    if (saToken) {
      setToken(saToken);
      setAccount(saAccount);
      setRole('superadmin');
      localStorage.removeItem('bo_sa_token');
      localStorage.removeItem('bo_sa_account');
    }
  };

  const logout = () => {
    const currentToken = token || localStorage.getItem('bo_token');
    if (currentToken) {
      api.post('/backoffice/auth/logout', null, {
        headers: { Authorization: `Bearer ${currentToken}` },
      }).catch(() => {});
    }
    setToken(null);
    setAccount(null);
    setRole(null);
    localStorage.removeItem('bo_sa_token');
    localStorage.removeItem('bo_sa_account');
  };

  const isSuperAdmin = role === 'superadmin';
  const isSwitchedFromSuperAdmin = !!localStorage.getItem('bo_sa_token');
  const isAuthenticated = !!token;

  return (
    <AuthContext.Provider value={{ token, account, role, isAuthenticated, isSuperAdmin, isSwitchedFromSuperAdmin, login, logout, switchToAccount, backToSuperAdmin, setAccount, setToken, setRole }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
